import type { ITaskStatus } from '@/types/task'

export const TASK_STATUS: { [K in ITaskStatus]: string } = {
  notStarted: 'Not Started',
  inProgress: 'In Progress',
  completed: 'Completed',
  inReview: 'In Review',
}

export const TASK_CREATION_DIALOG = {
  TITLE: 'New task',
  CREATE: 'Create task',
  NAME: 'Task Name',
  STATUS: 'Status',
  OWNER: 'Owner',
  CONTROL: 'Control',
  DESCRIPTION: 'Description',
  NOTES: 'Notes',
  BULK_UPLOAD: 'Bulk Upload',
  BULK_UPLOAD_TEMPLATE: 'Bulk Upload Template',
  DOCUMENT: 'Documents',
  EVIDENCE: 'Evidences',
  CANCEL: 'Cancel',
}

export const TASK_TABLE = {
  TITLE: 'Task List',
  TABLE_HEADER: {
    NAME: 'Name',
    STATUS: 'Status',
    OWNER: 'Owner',
    DEADLINE: 'Deadline',
    CLUSTER: 'Cluster',
    CREATED_AT: 'Created At',
  },
  NO_DEADLINE: 'No Deadline Assigned',
  NO_CREATED_AT: 'No Creation Date',
  OWNER_UPDATED: 'Owner updated successfully',
}

export const TASK_DETAILS = {
  DESCRIPTION: 'Description',
  STATUS: 'Status',
  DELETED: 'Task deleted successfully',
}

export const TASK_DELETE_DIALOG = {
  QUESTION: 'Are you sure you want to delete this task?',
  TITLE: 'Delete Task',
  CANCEL: 'Cancel',
  DELETE: 'Delete',
  CONFIRMATION: 'This action cannot be undone.',
}

export const TASK_DRAWER = {
  TASK_DETAILS: 'Task Details',
  DESCRIPTION: 'Description',
  ATTRIBUTES: 'Attributes',
  NOTES: 'Notes',
  DOCUMENTS: 'Documents',
  EVIDENCES: 'Evidences',
  TASK_UPDATED: 'Task updated',
  UPDATING: 'Updating task...',
  EVIDENCE_UPLOADS_TITLE: 'Evidence uploads',
  ADD_LINK_BUTTON: 'Add link',
  ADD_FILE_BUTTON: 'Add file',
  NO_UPLOADS_YET: 'No files yet',
  UPLOAD_FILE_ARIA: 'Upload file',
  REMOVE_FILE_ARIA: 'Remove',
}

export const TASK_HEADER = {
  TITLE: 'Task Manager',
  TOTAL_TASKS: 'total tasks',
  SEARCH_PLACEHOLDER: 'Search tasks...',
}

export const TASK_FILTERS = {
  CLEAR_FILTERS: 'Clear filters',
  CREATED_AT: 'Created At',
  DEADLINE: 'Deadline',
  FROM: 'From',
  TO: 'To',
}

export const TASK_LIST_HEADER = {
  NAME: 'Name',
  CLUSTER: 'Cluster',
  OWNER: 'Owner',
  CREATED_AT: 'Created At',
  DEADLINE: 'Deadline',
  STATUS: 'Status',
}

export const TASK_ITEM = {
  NO_DEADLINE: 'No deadline',
  UNASSIGNED: 'Unassigned',
}

export const TASK_ATTRIBUTES = {
  DEADLINE: 'Deadline',
  CREATED_AT: 'Created At',
  CONTROL: 'Control',
}

export const TASK_DESCRIPTION = {
  NO_DESCRIPTION: 'No description provided',
}

export const TASK_NOTES = {
  NO_NOTES: 'No notes added',
}

export const BULK_UPLOAD_DIALOG = {
  TITLE: 'Bulk Upload Tasks',
  DESCRIPTION: 'Upload a CSV or Excel file to create multiple tasks at once.',
  UPLOAD_FILE: 'Upload File',
  UPLOADING: 'Uploading...',
  TEMPLATE: 'Template',
  CREATING_TASKS: 'Creating tasks in bulk...',
  SUCCESS: 'Tasks created successfully',
  CANCEL: 'Cancel',
}

export const CONTROL_SELECTOR = {
  SELECT_CONTROLS: 'Select controls...',
  SELECT_CONTROL: 'Select control...',
  SEARCH_CONTROLS: 'Search controls...',
  NO_CONTROL_FOUND: 'No control found.',
}

export const DOCUMENT_SELECTOR = {
  LABEL: 'Documents',
  SELECT_DOCUMENTS: 'Select documents...',
  NO_DOCUMENTS_AVAILABLE: 'No documents available',
  SEARCH_DOCUMENTS: 'Search documents...',
  NO_DOCUMENT_FOUND: 'No document found.',
}

export const EVIDENCE_SELECTOR = {
  LABEL: 'Evidences',
  SELECT_EVIDENCES: 'Select evidences...',
  NO_EVIDENCES_AVAILABLE: 'No evidences available',
  SEARCH_EVIDENCES: 'Search evidences...',
  NO_EVIDENCE_FOUND: 'No evidence found.',
}

export const TASK_BULK_ACTIONS = {
  TASK: 'task',
  TASKS: 'tasks',
  SELECTED: 'selected',
  CLEAR: 'Clear',
  SELECT_STATUS: 'Select status',
  OWNER_UPDATED: 'Owner updated successfully',
  STATUS_UPDATED: 'Status updated successfully',
}

export const TASK_CSV_VALIDATION = {
  NAME_REQUIRED: 'Name is required.',
  CONTROL_REQUIRED: 'Control is required.',
  CONTROL_NOT_FOUND: (value: string) => `Control not found or invalid: "${value}".`,
  DOCUMENT_NOT_FOUND: (value: string) => `Document not found: "${value}".`,
  DOCUMENT_NOT_LINKED: (docName: string, controlName: string) =>
    `Document "${docName}" is not linked to control "${controlName}".`,
  EVIDENCE_NOT_FOUND: (value: string) => `Evidence not found: "${value}".`,
  EVIDENCE_NOT_LINKED: (evidenceName: string, controlName: string) =>
    `Evidence "${evidenceName}" is not linked to control "${controlName}".`,
  INVALID_DATE: (value: string) => `Invalid date: "${value}".`,
  CLUSTER_INVALID: (value: string) => `Invalid cluster: "${value}".`,
  ERRORS_HEADER: 'Errors were found in the CSV. No tasks were created.',
  LINE_LABEL: 'Line',
  COLUMN_LABEL: 'column',
  ERROR_CREATING_TASKS: 'Error creating tasks',
}
